// webpack entry: pull in styles + JS modules. Compiled to dist/assets/scripts/main.js
import '../styles/styles.scss';
import './modules/preloader.js';
import './modules/sticky-header.js';
import './modules/nav-overlay.js';
import './modules/lang-nav.js';
import './modules/accordion.js';
import './modules/recipe-timeline.js';
import './modules/print-recipe.js';
import './modules/about-timeline.js';
import './modules/drag-scroll.js';
import './modules/lazy-video.js';
import './modules/faq.js';
import './modules/dining-form.js';
// GSAP motion system (see .claude/GSAP_GUIDELINES_WORDPRESS.md)
import './modules/smooth-scroll.js';
import './modules/reveals.js';
import './modules/private-dinner-pin.js';
